import Image from "next/image";
import Link from "next/link";
import DarkMode from "../mode/DarkMode";
import Logo from "./../../public/images/logo.png";
import WhiteLogo from "./../../public/images/logo_white.png";
import { v4 as uuidv4 } from "uuid";
import { useRouter } from "next/router";
import {
  isChildrenPageActive,
  isParentPageActive,
} from "../../utils/daynamicNavigation";
import { useEffect, useState } from "react";
import WalletButton from "../wallet-btn/WalletButton";
import { Typography } from "@material-tailwind/react";
import { useElementHeight } from "../../helpers/useElementHeight";
import { Bit5Logo } from "../bit5Logo";
import { socialIcons } from "../../data/footer_data";

export default function Header01() {
  const [toggle, setToggle] = useState(false);
  const [isCollapse, setCollapse] = useState(null);
  const [warning, setWarning] = useState(
    process.env.NEXT_PUBLIC_ENV_VARIABLE !== "production" ? true : false
  );
  const [headerRef] = useElementHeight("--header-height");
  // window resize
  useEffect(() => {
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 1024) {
        setToggle(false);
      }
    });
  });

  const route = useRouter();
  /* -------------------------------------------------------------------------- */
  /*                            daynamic navigations                            */
  /* -------------------------------------------------------------------------- */

  const mobileCollapse = (id) => {
    if (isCollapse === id) {
      return setCollapse(null);
    }
    setCollapse(id);
  };

  return (
    <>
      {/* main desktop menu sart*/}
      <header
        ref={headerRef}
        className="js-page-header fixed top-0 z-50 w-full backdrop-blur transition-colors"
      >
        {warning && (
          <div className="flex py-3 items-center justify-center bg-orange relative">
            <span className="leading-4">You are using Testnet.</span>
            <Link href="https://testnet-mint-app.vercel.app/">
              <a target={"_blank"} className="ml-2 font-bold underline">
                Mint Now
              </a>
            </Link>
          </div>
        )}
        <div className="flex items-center py-6 container mx-auto  ">
          <a href="https://bit5.com">
            <Bit5Logo />
          </a>

          <div className="js-mobile-menu dark:bg-jacarta-800 invisible fixed inset-0 z-10 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:flex lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent">
            <nav className="navbar ">
              <ul className="flex flex-col lg:flex-row">
                <li className="group">
                  <Link href="/">
                    <a>
                      <button className="font-display whitespace-nowrap hover:text-accent focus:text-accent hover:text-accent focus:text-accent flex items-center justify-between py-3.5 text-base text-accent dark:text-white lg:px-5">
                        <span
                          className={
                            isChildrenPageActive(route.asPath, "/")
                              ? "text-accent dark:text-accent"
                              : ""
                          }
                        >
                          Main
                        </span>
                      </button>
                    </a>
                  </Link>
                </li>

                <li className="group">
                  <Link href="/borrow">
                    <a>
                      <button className="font-display hover:text-accent focus:text-accent hover:text-accent focus:text-accent flex items-center justify-between py-3.5 text-base text-accent dark:text-white lg:px-5">
                        <span
                          className={
                            isChildrenPageActive(route.asPath, "/borrow")
                              ? "text-accent dark:text-accent"
                              : ""
                          }
                        >
                          Borrow
                        </span>
                      </button>
                    </a>
                  </Link>
                </li>

                <li className="group">
                  <Link href="/lend">
                    <a>
                      <button className="font-display hover:text-accent focus:text-accent hover:text-accent focus:text-accent flex items-center justify-between py-3.5 text-base text-accent dark:text-white lg:px-5">
                        <span
                          className={
                            isChildrenPageActive(route.asPath, "/lend")
                              ? "text-accent dark:text-accent"
                              : ""
                          }
                        >
                          Lend
                        </span>
                      </button>
                    </a>
                  </Link>
                </li>

                <li className="group">
                  <Link href="/account">
                    <a>
                      <button className="font-display hover:text-accent focus:text-accent hover:text-accent focus:text-accent flex items-center justify-between py-3.5 text-base text-accent dark:text-white lg:px-5">
                        <span
                          className={
                            isChildrenPageActive(route.asPath, "/account")
                              ? "text-accent dark:text-accent"
                              : ""
                          }
                        >
                          Account
                        </span>
                      </button>
                    </a>
                  </Link>
                </li>
              </ul>
            </nav>
            {/* End menu for desktop */}

            <div className="ml-8 w-full hidden items-center lg:flex xl:ml-12">
              <WalletButton />
              {/* End metamask Wallet */}
              <DarkMode />
            </div>
            {/* End header right content (metamask and other) for desktop */}
          </div>
          {/* header menu conent end for desktop */}

          <div className="ml-auto flex lg:hidden">
            <DarkMode />
            <button
              className="js-mobile-toggle border-jacarta-100 hover:bg-accent dark:hover:bg-accent focus:bg-accent group ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
              aria-label="open mobile menu"
              onClick={() => setToggle(!toggle)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={24}
                height={24}
                className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M18 18v2H6v-2h12zm3-7v2H3v-2h18zm-3-7v2H6V4h12z" />
              </svg>
            </button>
          </div>
          {/* End header right content  for mobile */}
        </div>
        {/* End flex item */}
      </header>
      {/* main desktop menu end */}

      {/* start mobile menu and it's other materials  */}
      <div
        className={`lg:hidden js-mobile-menu dark:bg-jacarta-800 invisible fixed inset-0 z-20 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent ${
          toggle ? "nav-menu--is-open" : "hidden"
        }`}
      >
        <nav className="navbar w-full">
          <ul className="flex flex-col lg:flex-row mt-[var(--header-height)]">
            <li className="group" onClick={() => setToggle(false)}>
              <Link href="/">
                <a>
                  <button className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                    <span
                      className={
                        isChildrenPageActive("/", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                      }
                    >
                      Main
                    </span>
                  </button>
                </a>
              </Link>
            </li>
            <li className="group" onClick={() => setToggle(false)}>
              <Link href="/borrow">
                <a>
                  <button className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                    <span
                      className={
                        isChildrenPageActive("/borrow", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                      }
                    >
                      Borrow
                    </span>
                  </button>
                </a>
              </Link>
            </li>
            <li className="group" onClick={() => setToggle(false)}>
              <Link href="/lend">
                <a>
                  <button className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                    <span
                      className={
                        isChildrenPageActive("/lend", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                      }
                    >
                      lend
                    </span>
                  </button>
                </a>
              </Link>
            </li>
            <li className="group" onClick={() => setToggle(false)}>
              <Link href="/account">
                <a>
                  <button className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                    <span
                      className={
                        isChildrenPageActive("/account", route.asPath)
                          ? "text-accent dark:text-accent"
                          : ""
                      }
                    >
                      Account
                    </span>
                  </button>
                </a>
              </Link>
            </li>
          </ul>
        </nav>
        {/* End navbar mobile menu  */}

        <div className="mt-10 w-full lg:hidden">
          <div className="flex justify-center">
            <WalletButton />
          </div>
          <hr className="dark:bg-jacarta-600 bg-jacarta-100 my-5 h-px border-0" />
          <div className="flex space-x-5 col-span-3 md:col-span-1 mt-6 md:mt-0 justify-center md:justify-end">
            {socialIcons.map((item) => {
              const { id, href, text } = item;
              return (
                <Link href={href} key={id}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group cursor-pointer"
                  >
                    <svg className="icon group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                      <use xlinkHref={`/icons.svg#icon-${text}`}></use>
                    </svg>
                  </a>
                </Link>
              );
            })}
          </div>
        </div>
        {/* mt-10 w-full lg:hidden */}
      </div>
      {warning && <div className="h-[48px]"></div>}
      {/* End mobile menu and it's other materials */}
    </>
  );
}
